// IE 2026 10 10 / ODOO-345813 (заказ Игоря: окна остановок регламента): чипс шапки стола «Regimen paused until 05:00 UTC (3 nodes)» — чистая логика (без Vue / DOM / стора).
// Бэк (common_modules/schedule_pause_wiring.py, 9d1ee7ef8) кладёт в WORKSPACE при workspace_open и в ответ executeBackendMethod 'schedule_header_chip' список header_chips
// ([] — показывать нечего) и штамп набора окон schedule_stamp (тот же штамп приходит в опросе auto_recalc_state). Тексты чипса бэк строит сам, на языке пользователя;
// рисует чипс существующий отрисовщик CHIP-Info (AttrChips.vue, режим Page), крестика у него нет (doc.static). Старый бэк ключей не шлёт — тогда ничего не рисуется и
// ничего не запрашивается. Стор (mainStore.apply_header_chips / scheduleHeaderChip_*) зовёт эти функции; выключатель fe.ux.scheduleHeaderChip (по умолчанию вкл.).
// Тесты — tests/unit/scheduleChip.test.mjs.

export const SCHEDULE_CHIP_FLAG = 'fe.ux.scheduleHeaderChip'
export const SCHEDULE_CHIP_SLACK_MS = 1500          // перезапрос — через 1,5 с после refresh_at: бэк сверяет время при каждом вызове
export const SCHEDULE_CHIP_RETRY_MS = 15000         // refresh_at уже в прошлом (часы браузера и сервера расходятся) — не чаще раза в 15 с, дальше вдвое реже
export const SCHEDULE_CHIP_RETRY_MAX_MS = 300000    // ... но не реже раза в 5 минут
export const SCHEDULE_CHIP_CAP_MS = 3600000         // таймер не длиннее часа: setTimeout дольше 2^31-1 мс срабатывает сразу, а сон машины растягивает длинный таймер
export const SCHEDULE_CHIP_GAP_MS = 3000            // запросы одного стола — не чаще раза в 3 с (таймер и штамп опроса сошлись в одну секунду)
export const SCHEDULE_CHIP_STALE_MS = 60000         // возврат к столу: чипс старше минуты — один перезапрос

const isObj = (x) => !!x && typeof x === 'object' && !Array.isArray(x)

// выключатель: выключается только явным false (store.setting — настройка базы / адрес ?fe.ux.scheduleHeaderChip=false / localStorage feSettings)
export function scheduleChip_on(store) {
    try { return !(store && typeof store.setting === 'function' && store.setting(SCHEDULE_CHIP_FLAG, true) === false) } catch (e) { return true }
}

// список чипсов бэка → только годные (объект с непустым title); не список — []
export function scheduleChip_list(list) {
    return (Array.isArray(list) ? list : []).filter(c => isObj(c) && typeof c.title === 'string' && c.title !== '')
}

// чипсы бэка → виртуальные чипсы полосы AttrChips (CHIP-Info): тот же отрисовщик, что у информационных чипсов отчётов; _index -1 — у них нет позиции среди настоящих
export function scheduleChip_virtual(list) {
    return scheduleChip_list(list).map(c => ({
        segment: 'CHIP-Info',
        _isVirtual: true,
        _index: -1,
        title: c.title,
        meta: { use: true, pi: c.pi || 'pi-info-circle', cssClass: c.cssClass || '' },
        doc: c,
    }))
}

// ответ метода schedule_header_chip → что положить на стол. Нет списка header_chips (старый бэк, ошибка) — чипс снят, а стол больше не спрашивает (off):
// иначе опрос штампа гонял бы запрос с ошибкой каждые 12 с
export function scheduleChip_answer(answer) {
    if (!isObj(answer) || !Array.isArray(answer.header_chips)) return { chips: [], stamp: undefined, off: true }
    return { chips: scheduleChip_list(answer.header_chips), stamp: typeof answer.schedule_stamp === 'string' ? answer.schedule_stamp : undefined, off: false }
}

// стол «знает» чипс окон остановки: бэк прислал оба ключа (header_chips — список, schedule_stamp — строка) и ответ не отказан. Старый бэк ключей не шлёт — тогда false,
// и ни запросов, ни сравнения штампов
export function scheduleChip_supported(WS) {
    return isObj(WS) && Array.isArray(WS.header_chips) && typeof WS.schedule_stamp === 'string' && !WS._scheduleOff
}

// через сколько мс перезапросить чипс: ближайший refresh_at (нет — until) всех чипсов + 1,5 с; null — конца нет ни у одного окна, таймер не нужен.
// Конец уже в прошлом по часам браузера — past: не чаще раза в 15 с, на каждом следующем подряд вдвое реже (retry — сколько раз подряд так было), потолок 5 минут
export function scheduleChip_delay(chips, nowMs, retry = 0) {
    let at = null
    for (const c of Array.isArray(chips) ? chips : []) {
        const ts = Date.parse(String((isObj(c) && (c.refresh_at || c.until)) || ''))
        if (Number.isFinite(ts) && (at === null || ts < at)) at = ts
    }
    if (at === null) return null
    const d = at - nowMs + SCHEDULE_CHIP_SLACK_MS
    if (d > SCHEDULE_CHIP_SLACK_MS) return { ms: Math.min(d, SCHEDULE_CHIP_CAP_MS), past: false }
    const n = Math.min(5, Math.max(0, Number(retry) | 0))
    return { ms: Math.min(SCHEDULE_CHIP_RETRY_MAX_MS, SCHEDULE_CHIP_RETRY_MS * 2 ** n), past: true }
}

// штамп набора окон из опроса auto_recalc_state отличается от того, под который посчитан чипс стола: окно началось / кончилось / продлено — перечитать чипс.
// Ответ без штампа (старый бэк) или стол без ключей — нет
export function scheduleChip_stampChanged(WS, stamp) {
    return typeof stamp === 'string' && scheduleChip_supported(WS) && stamp !== WS.schedule_stamp
}

// чипс стола пора перечитать при возврате к нему: прошла минута с последнего ответа, или ответа не было, или язык интерфейса сменился (тексты бэк строит на языке запроса)
export function scheduleChip_stale(WS, nowMs, lang) {
    if (!scheduleChip_supported(WS)) return false
    const at = Number(WS._scheduleAt)
    if (!Number.isFinite(at) || at <= 0) return true
    if (WS._scheduleLang && lang && WS._scheduleLang !== lang) return true
    return nowMs - at > SCHEDULE_CHIP_STALE_MS
}

// можно ли сейчас спросить бэк про этот стол: он знает чипс и прошлый запрос был не меньше 3 с назад (force — действие пользователя, например смена языка: без паузы)
export function scheduleChip_canAsk(WS, nowMs, force = false) {
    if (!scheduleChip_supported(WS)) return false
    if (force) return true
    const at = Number(WS._scheduleReqAt)
    return !(Number.isFinite(at) && at > 0 && nowMs - at < SCHEDULE_CHIP_GAP_MS)
}
